import React from 'react'

import {AdminContext} from 'contexts/AdminContext'

import { Col, Row } from '_zari/core'

import RecalcularCostoOperacion from './recalcularCosto'
import RecalcularStockOperacion from './recalcularStock'
import ValorizarTodoOperacion from './valorizarTodo'
import ObtenerSaldosAnoPasado from './obtenerSaldosAnoPasado'
import ObtenerStocksPasadosxSede from './obtenerStocksPasadosxSede'

const InventarioFisicoOperaciones = () => {
  const __adminContext = React.useContext(AdminContext)

  return (
    <Row>
      <Col md={6}>
        <RecalcularStockOperacion />
      </Col>
      <Col md={6}>
        <ValorizarTodoOperacion />
      </Col>
      <Col md={6}>
        <RecalcularCostoOperacion />
      </Col>
      <Col md={6}>
        <ObtenerStocksPasadosxSede />
      </Col>
      {
        __adminContext.mesTrabajo === '00' && (
          <Col md={6}>
            <ObtenerSaldosAnoPasado />
          </Col>    
        )
      }
      
    </Row>
  )
}

export default InventarioFisicoOperaciones
